import LineHeight25 from '@assets/icons/line-height-25.svg'
import { Icon } from './Icon'

export const LineHeight25Icon = Icon(LineHeight25)
